import React, { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography';
import MediaStyles from './Media.module.css';
import { Box, Button } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { Link } from 'react-router-dom';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import axios from 'axios';

export const Media = () => {

    const [eventData, setEventData] = useState();
    const [galleryData, setGalleryData] = useState();


    const formatDate = (date) => {
        return date ? new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' }).replace(/\//g, '.') : '';
    };

    // -----------------------------------------------------------------------------------------------

    const getEventsData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/upcomingevents/getAllUpcomingEvents`
            )
            setEventData(res.data)
            const dates = res.data.map((item) => {
                const [day, month, year] = item.date.split('.');
                return (
                    new Date(year, month - 1, day).getTime()
                )
            })
            const maxDate = new Date(Math.max(...dates));
            setEventData(maxDate);
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getEventsData()
    }, [])


    // -----------------------------------------------------------------------------------------------


    const getGalleryData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/gallery/getAllImages`
            )
            setGalleryData(res.data);
            const dates = res.data.map((item) => {
                const [day, month, year] = item.date.split('.');
                return (
                    new Date(year, month - 1, day).getTime()
                )
            })
            const maxDate = new Date(Math.max(...dates));
            setGalleryData(maxDate);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getGalleryData()
    }, [])


    // -----------------------------------------------------------------------------------------------
    return (
        <div className={MediaStyles.mediaMain}>
            <div className={MediaStyles.mediaContent}>
                <Typography sx={{ marginTop: '2%', color: '#121926', fontWeight: '600', fontSize: '20px', paddingBottom: '3%' }} >
                    Media
                </Typography>
                <Box className={MediaStyles.mediaComponent}>
                    <div className={MediaStyles.mediaComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Title
                        </Typography>
                    </div>
                    <div className={MediaStyles.mediaComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Last modified
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Action
                        </Typography>
                    </div>
                </Box>
                <Box className={MediaStyles.mediaComponent}>
                    <div className={MediaStyles.mediaComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Upcoming Events
                        </Typography>
                    </div>
                    <div className={MediaStyles.mediaComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                            {formatDate(eventData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='/upcomingevents'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
                <Box className={MediaStyles.mediaComponent}>
                    <div className={MediaStyles.mediaComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Gallery
                        </Typography>
                    </div>
                    <div className={MediaStyles.mediaComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                            {formatDate(galleryData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='/gallery'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
                <Box className={MediaStyles.mediaComponent}>
                    <div className={MediaStyles.mediaComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Posts
                        </Typography>
                    </div>
                    <div className={MediaStyles.mediaComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                            {formatDate(galleryData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='posts'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
            </div>
        </div>
    )
}

export default Media